import messageChannelService from '../message-channel.service'
import { withRetry } from '../../../utilities/pinpad-v2/retry'
import { logInfo, logError, logWarn } from '../../../utilities/pinpad-v2/logger'

class TransactionService {
  async sndVentaDirectaEMV(params) {
    const payload = {
      Ambiente: params?.Ambiente,
      Country: params?.Country,
      IdBranch: params?.IdBranch,
      IdCompany: params?.IdCompany,
      pwd: params?.pwd,
      User: params?.User,
      UserTRX: params?.UserTRX,
      EMV: params?.EMV,
      ModeloTerminal: params?.ModeloTerminal,
      SerieTerminal: params?.SerieTerminal,
      Contactless: params?.Contactless,
      Printer: 1, //params?.Printer,
      VersionTerminal: params?.VersionTerminal,
      TpOperation: params?.TpOperation,
      Reference: params?.Reference,
      Currency: params?.Currency,
      Merchant: params?.Merchant,
      Reverse: params?.Reverse
    }

    const required = [
      'Ambiente', 'Country', 'IdBranch', 'IdCompany', 'pwd', 'User', 'UserTRX',
      'EMV', 'ModeloTerminal', 'SerieTerminal', 'Printer', 'VersionTerminal',
      'TpOperation', 'Reference', 'Currency', 'Merchant'
    ]
    const missing = required.filter((field) => payload[field] === undefined || payload[field] === null || payload[field] === '')
    if (missing.length) {
      const error = new Error(`Missing required parameters: ${missing.join(', ')}`)
      error.code = 'INVALID_PARAMETERS'
      throw error
    }

    const ventaFn = async () => {
      logInfo('sndVentaDirectaEMV payload prepared', {
        payload,
      })

      const response = await messageChannelService.sendMessage('sndVentaDirectaEMV', payload, 120000)

      logInfo('sndVentaDirectaEMV response received', {
        reference: payload.Reference,
        response,
      })

      return response
    }

    try {
      logInfo('Starting sndVentaDirectaEMV operation', {
        reference: payload.Reference,
        currency: payload.Currency,
        merchant: payload.Merchant,
        tpOperation: payload.TpOperation
      })
      const response = await withRetry(ventaFn, { operation: 'VENTA' })
      if (response?.response === 'denied') {
        logWarn('Transaction denied', { reference: payload.Reference, code: response?.cd_response })
      }
      if (response?.response === 'error' || response?.RESPUESTA === 'error') {
        const error = new Error(response?.nb_error || response?.ERROR || 'Transaction error')
        error.code = response?.cd_error || response?.codError || 'VENTA_ERROR'
        throw error
      }
      return response
    } catch (error) {
      logError('sndVentaDirectaEMV failed', error, { reference: payload.Reference })
      throw error
    }
  }

  async sndVentaDirectaToken(params) {
    const amount = Number.parseFloat(params?.Amount)
    if (Number.isNaN(amount)) {
      const error = new Error('Amount is required for sndVentaDirectaToken with decimal format')
      error.code = 'INVALID_AMOUNT_FORMAT'
      throw error
    }

    const payload = {
      ...params,
      Amount: amount.toFixed(2),
      GenerateToken: !!params?.GenerateToken
    }

    const ventaTokenFn = async () => {
      logInfo('sndVentaDirectaToken payload prepared', {
        payload,
      })

      const response = await messageChannelService.sendMessage('sndVentaDirectaToken', payload, 120000)

      logInfo('sndVentaDirectaToken response received', {
        reference: payload.Reference,
        response,
      })

      return response
    }

    try {
      logInfo('Starting sndVentaDirectaToken operation', { reference: payload.Reference, amount: payload.Amount })
      return await withRetry(ventaTokenFn, { operation: 'VENTA' })
    } catch (error) {
      logError('sndVentaDirectaToken failed', error, { reference: payload.Reference })
      throw error
    }
  }

  async sndReimpresion(params) {
    const payload = {
      Ambiente: params?.Ambiente,
      User: params?.User,
      Pwd: params?.Pwd,
      IdBranch: params?.IdBranch,
      IdCompany: params?.IdCompany,
      Country: params?.Country,
      Tx_OperationNumber: params?.Tx_OperationNumber,
      Tx_Auth: params?.Tx_Auth,
      Amount: params?.Amount,
      Date: params?.Date,
      Merchant: params?.Merchant,
      Currency: params?.Currency
    }

    const required = ['Ambiente', 'User', 'Pwd', 'IdBranch', 'IdCompany', 'Country', 'Tx_OperationNumber']
    const missing = required.filter((field) => !payload[field])
    if (missing.length) {
      const error = new Error(`Missing required parameters: ${missing.join(', ')}`)
      error.code = 'INVALID_PARAMETERS'
      throw error
    }

    const reimpresionFn = async () => {
      logInfo('sndReimpresion payload prepared', {
        payload,
      })

      const response = await messageChannelService.sendMessage('sndReimpresion', payload, 60000)

      logInfo('sndReimpresion response received', {
        folio: payload.Tx_OperationNumber,
        response,
      })

      return response
    }

    try {
      logInfo('Starting sndReimpresion operation', { folio: payload.Tx_OperationNumber })
      return await withRetry(reimpresionFn, { operation: 'REIMPRESION' })
    } catch (error) {
      logError('sndReimpresion failed', error, { folio: payload.Tx_OperationNumber })
      throw error
    }
  }
}

const transactionService = new TransactionService()

export default transactionService
